import React, { useEffect, useState } from "react";
import { Phone, MessageSquare, X, ArrowUp } from "lucide-react";
import { KM } from "../../data/km";

// Phones only: floating call / text shortcut that appears after the hero
export default function QuickContact() {
  const [show, setShow] = useState(false);
  const [open, setOpen] = useState(false);
  const [top, setTop] = useState(false);
  const tel = KM.phone.replace(/[^\d]/g, "");
  // "?&body=" is understood by both iPhone and Android messaging apps
  const smsBody = encodeURIComponent("Hi Kristin, I found you on your website and would love to connect about ");
  const smsHref = `sms:+1${tel}?&body=${smsBody}`;

  useEffect(() => {
    const on = () => {
      const past = window.scrollY > window.innerHeight * 0.6;
      setShow(past);
      setTop(window.scrollY > window.innerHeight);
      if (!past) setOpen(false);
    };
    on();
    window.addEventListener("scroll", on, { passive: true });
    return () => window.removeEventListener("scroll", on);
  }, []);

  const pill = "flex items-center gap-3 bg-white text-[#141414] border border-black/10 shadow-[0_8px_24px_-8px_rgba(0,0,0,0.35)] pl-4 pr-5 h-12 km-eyebrow text-[10px] transition-all duration-300";

  return (
    <>
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="Back to top"
      className={`sm:hidden fixed right-[22px] z-[60] w-11 h-11 rounded-full bg-white text-[#141414] border border-[#141414] flex items-center justify-center shadow-[0_6px_18px_-8px_rgba(0,0,0,0.35)] active:scale-95 transition-all duration-500 ${top && !open ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"}`}
      style={{ bottom: "calc(1rem + 56px + 12px + env(safe-area-inset-bottom))" }}
      data-testid="back-to-top"
    >
      <ArrowUp size={18} strokeWidth={1.4} />
    </button>
    <div
      className={`sm:hidden fixed right-4 z-[60] flex flex-col items-end gap-3 pointer-events-none transition-all duration-500 ${show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}
      style={{ bottom: "calc(1rem + env(safe-area-inset-bottom))" }}
      data-testid="quick-contact"
    >
      <a href={smsHref} className={`${pill} ${open && show ? "opacity-100 translate-y-0 pointer-events-auto" : "opacity-0 translate-y-3"}`} style={{ transitionDelay: open ? "60ms" : "0ms" }} data-testid="quick-text">
        <MessageSquare size={16} strokeWidth={1.5} /> Text Kristin
      </a>
      <a href={`tel:+1${tel}`} className={`${pill} ${open && show ? "opacity-100 translate-y-0 pointer-events-auto" : "opacity-0 translate-y-3"}`} data-testid="quick-call">
        <Phone size={16} strokeWidth={1.5} /> Call {KM.phone}
      </a>
      <button
        onClick={() => setOpen(!open)}
        aria-label={open ? "Close quick contact" : "Call or text Kristin"}
        aria-expanded={open}
        className={`${show ? "pointer-events-auto" : ""} w-14 h-14 rounded-full bg-[#141414] text-white flex items-center justify-center shadow-[0_10px_28px_-8px_rgba(0,0,0,0.55)] active:scale-95 transition-transform`}
        data-testid="quick-toggle"
      >
        {open ? <X size={22} strokeWidth={1.4} /> : <Phone size={22} strokeWidth={1.4} />}
      </button>
    </div>
    </>
  );
}
